import React, { useEffect, useState } from "react";
import _ from "lodash";
import imgContinuar from "../../assets/images/factor-ct/boton-continuar.png";
import imgEnviar from "../../assets/images/factor-ct/boton-enviar.png";
import imgGenerar from "../../assets/images/factor-ct/boton-generar.png";
import imgTitle from "../../assets/images/factor-ct/title.png";
import imgExample from "../../assets/images/factor-ct/example.png";
import imgInstrucciones from "../../assets/images/factor-ct/instrucciones.png";
import { useSearchParams } from "react-router-dom";

import {
  FactorCtContainerStyled,
  Header,
  Titles,
  AfirmationsContainer,
  AfirmationsHeader,
  AfirmationContainer,
  Answer,
  AfirmationColumn,
  YesColumn,
  NAColumn,
  NoColumn,
  InstruccionesContainer,
  ButtonCt,
  InstruccionesInside,
  MaxWidth,
  InstruccionRow,
  InstruccionRowImgContainer,
  PdfAlreadyGenerated,
} from "./factorCtStyles";
import axios, { EnpointsUrlBase } from "../../helpers/axios";
import JSZip from "jszip";

const FactorCtContainer = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [isFirstTime, setIsFirstTime] = useState(false);
  const [showPrintPdfMessage, setShowPrintPdfMessage] = useState(false);
  const [theAffirmations, setTheAffirmations] = useState<any>([]);
  const [letrasMayores, setLetrasMayores] = useState<any>("");
  const [isGuardando, setIsGuardando] = useState(false);

  const [buttonDisabled, setButtonDisabled] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();

  const idUsuario = searchParams.get("i") || "";
  const nombreUsuario = searchParams.get("u") || "";
  const empresa = searchParams.get("e") || "";
  const email = searchParams.get("m") || "";
  const programa = searchParams.get("p") || "";
  const stopGeneratingAutomatically = (searchParams.get("hr") || "") === "1";

  const onAnswerClick = (
    affirmationId: number,
    optionSelected: string,
    puntaje: number
  ) => {
    if (isGuardando) return;
    //acá enviamos al server para guardar la respuesta
    //  public string IdUsuario { get; set; } = "";
    //public string NombreUsuario { get; set; } = "";
    //public string EmailUsuario { get; set; } = "";
    //public string EmpresaUsuario { get; set; } = "";
    //public string ProgramaUsuario { get; set; } = "";
    //public int Intento { get; set; }

    //public Guid AfirmacionId { get; set; }
    //public string TextoRespuesta { get; set; }

    if (showPrintPdfMessage) return;
    setIsGuardando(true);

    const toAnswer = {
      idUsuario: idUsuario,
      nombreUsuario: nombreUsuario,
      emailUsuario: email,
      empresaUsuario: empresa,
      programaUsuario: programa,
      intento: 1,
      afirmacionId: affirmationId,
      textoRespuesta: optionSelected,
    };

    axios.post(
      `${EnpointsUrlBase}/FactorCt/GuardarRespuesta`,
      toAnswer,
      (res: any, data: any) => {
        if (res === 200) {
          setIsGuardando(false);
          if (data.length === 3) setLetrasMayores(data);
        } else {
          console.log("Error saving");
        }
      }
    );

    var newData = theAffirmations.map((k: any) => {
      if (k.id == affirmationId) {
        return {
          ...k,
          optionSelected: optionSelected,
          puntaje: puntaje,
        };
      } else {
        return { ...k };
      }
    });
    setTheAffirmations(newData);
  };

  const getFileName = () => {
    if (letrasMayores && letrasMayores.length === 3)
      return `${letrasMayores[0].toUpperCase()}-${letrasMayores[1].toUpperCase()}-${letrasMayores[2].toUpperCase()}`;
    else return "";
  };

  const handleClickContinue = () => {
    setShowPrintPdfMessage(true);
    if (stopGeneratingAutomatically) return;

    const pdfPath = `/reports/factor-ct/Formato CT _ ${getFileName()}.pdf`;
    const link = document.createElement("a");
    link.href = pdfPath;
    link.setAttribute(
      "download",
      `Factor CT(${nombreUsuario})-(${programa}).pdf`
    );
    document.body.appendChild(link);
    link.click();
    link?.parentNode?.removeChild(link);
  };

  const isEnabled = () => {
    let toReturn = true;

    for (const af of theAffirmations) {
      if (af.optionSelected === "") {
        toReturn = false;
        break;
      }
    }
    if (isFirstTime && toReturn) {
      setCurrentStep(2);
      setShowPrintPdfMessage(true);
    }

    return toReturn;
  };

  useEffect(() => {
    const getPreguntas = () => {
      axios.get(
        `${EnpointsUrlBase}/FactorCt/GetPreguntas` + window.location.search,
        (res: any, data: any) => {
          if (res === 200) {
            if (data) {
              const affirmationsConverted = data.respuestas.map((aff: any) => ({
                optionSelected: aff.valor,
                id: aff.afirmacion.id,
                afirmacion: aff.afirmacion.textos,
                letra: aff.afirmacion.letra,
                puntaje: aff.puntaje,
              }));
              setIsFirstTime(true);
              setTheAffirmations(affirmationsConverted);
              setLetrasMayores(data.encabezado.letrasMayores);
            }
          }
          //setLoading(false);
        }
      );
    };

    getPreguntas();
  }, []);

  useEffect(() => {
    setButtonDisabled(!isEnabled());

    if (isFirstTime) setIsFirstTime(false);
  }, [theAffirmations]);

  return (
    <FactorCtContainerStyled>
      <Header>
        <Titles>
          <img src={imgTitle} alt="" />
        </Titles>
        <div>
          <img
            src={
              require(`../../assets/images/estilo-aprendizaje/logos/1/logoleft.svg`)
                .default
            }
            alt=""
          />
          <img
            src={
              require(`../../assets/images/estilo-aprendizaje/logos/1/logoright.svg`)
                .default
            }
            alt=""
          />
        </div>
      </Header>
      <MaxWidth>
        {/*import imgTitle from '../../assets/images/factor-ct/title.png';*/}
        {/*import imgExample from '../../assets/images/factor-ct/example.png';*/}
        {/*import imgInstrucciones from '../../assets/images/factor-ct/instrucciones.png';*/}
        {currentStep == 1 && (
          <AfirmationsContainer>
            <InstruccionesContainer>
              <InstruccionesInside>
                <h1 style={{ color: "#003c4d" }}>Instrucciones:</h1>
                <InstruccionRow>
                  <InstruccionRowImgContainer>
                    <img src={imgExample} alt="" />
                  </InstruccionRowImgContainer>

                  <div></div>

                  <div className="parrafo">
                    Responda a la lista de afirmaciones que encontrará a
                    continuación con una de estas tres opciones:
                    <ul>
                      <li>
                        <b>Sí</b> (la cumple)
                      </li>
                      <li>
                        <b>No</b> (no la cumple)
                      </li>
                      <li>
                        <b>¿?</b> (la cumple parcialmente)
                      </li>
                    </ul>
                  </div>
                </InstruccionRow>

                <InstruccionRow>
                  <InstruccionRowImgContainer>
                    <img src={imgInstrucciones} alt="" />
                  </InstruccionRowImgContainer>

                  <div></div>
                  <div className="parrafo pequeno">
                    <p>
                      Este aplicativo guardará las respuestas que vaya
                      eligiendo. En caso de salir o tener que interrumpir el
                      test, al volver a ingresar podrá modificarlas o continuar
                      respondiendo. Una vez finalice y haga clic en el botón
                      "Enviar", podrá descargar sus resultados.
                    </p>
                  </div>
                </InstruccionRow>

                <InstruccionRow>
                  {/*Este aplicativo guardará sus respuestas para que, si necesita salir, cuando vuelva pueda modificarlas o continuar respondiendo, sin embargo, una vez haga clic en el botón Enviar las respuestas se guardarán y ya no será posible modificarlas. También al hacer clic en el botón Terminar obtendrá su informe de Factor CT.*/}
                </InstruccionRow>
              </InstruccionesInside>
            </InstruccionesContainer>
            <ButtonCt
              type="button"
              onClick={() => {
                setCurrentStep(2);
              }}>
              <img src={imgContinuar} alt="" />
            </ButtonCt>
          </AfirmationsContainer>
        )}
        {currentStep == 2 && !showPrintPdfMessage && (
          <AfirmationsContainer>
            <AfirmationsHeader>
              <AfirmationColumn>
                <h1>Afirmación</h1>
              </AfirmationColumn>
              <YesColumn>
                <h1>Sí</h1>
              </YesColumn>
              <NAColumn>
                <h1>¿?</h1>
              </NAColumn>
              <NoColumn>
                <h1>No</h1>
              </NoColumn>
            </AfirmationsHeader>
            {theAffirmations.map((af: any) => (
              <AfirmationContainer key={af.id}>
                <AfirmationColumn>
                  <span>{af.afirmacion}</span>
                </AfirmationColumn>
                <YesColumn>
                  <Answer
                    className={af.optionSelected === "yes" ? "X" : ""}
                    onClick={() => onAnswerClick(af.id, "yes", 1)}
                  />
                </YesColumn>
                <NAColumn>
                  <Answer
                    className={af.optionSelected === "¿?" ? "X" : ""}
                    onClick={() => onAnswerClick(af.id, "¿?", 0.5)}
                  />
                </NAColumn>
                <NoColumn>
                  <Answer
                    className={af.optionSelected === "no" ? "X" : ""}
                    onClick={() => onAnswerClick(af.id, "no", 0)}
                  />
                </NoColumn>
              </AfirmationContainer>
            ))}

            {!showPrintPdfMessage && (
              <>
                <ButtonCt
                  disabled={buttonDisabled}
                  onClick={handleClickContinue}>
                  <img src={imgEnviar} alt="" />
                </ButtonCt>
              </>
            )}
            {showPrintPdfMessage && (
              <PdfAlreadyGenerated>
                Usted ya ha realizado esta introspección.
                {stopGeneratingAutomatically !== true && (
                  <>
                    Si desea generar nuevamente su informe haga
                    <a href="#" onClick={handleClickContinue}>
                      Clic aqui
                    </a>
                  </>
                )}
              </PdfAlreadyGenerated>
            )}
          </AfirmationsContainer>
        )}
        {currentStep == 2 && showPrintPdfMessage && (
          <AfirmationsContainer>
            <InstruccionesContainer>
              <InstruccionesInside>
                <div style={{ paddingTop: "100px" }}>
                  Gracias por haber realizado esta introspección.
                  {stopGeneratingAutomatically !== true && (
                    <>Si desea generar nuevamente su informe haga</>
                  )}
                </div>
                {stopGeneratingAutomatically !== true && (
                  <button
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      marginTop: "20px",
                    }}>
                    <a href="#" onClick={handleClickContinue}>
                      <img style={{ width: "200px" }} src={imgGenerar} />
                    </a>
                  </button>
                )}
              </InstruccionesInside>
            </InstruccionesContainer>
          </AfirmationsContainer>
        )}
      </MaxWidth>
    </FactorCtContainerStyled>
  );
};

export default FactorCtContainer;
